import {
  ConnectionListResult,
  filterOutNullAndUndefined,
  GridSortProps,
  PaginatedQueryWrapper,
  SelectionProviderChildProps
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import {
  TableColumnsByIdQuery,
  TableColumnsByIdQuery_tablesConnection_nodes_DatabaseTable_columnsConnection_nodes,
  TableColumnsByIdQueryVariables,
} from '../../../gen-src/queries/TableColumnsByIdQuery';
import { ColumnSortOrder } from '../../../gen-src/queries/globalTypes';
import { TableColumnsByIdQueryGql } from '../../queries/TableColumnsByIdQueryGql';
import { ColumnsValidSortFields } from '../sorting/sortProviders/ColumnsGridSortProvider';
import { TableColumnsDisplayGrid, TableColumnsGridRowData } from './TableColumnsDisplayGrid';

export type QueryVariables = TableColumnsByIdQueryVariables;
export type QueryResults = TableColumnsByIdQuery;
export type QueryResultListNode = TableColumnsByIdQuery_tablesConnection_nodes_DatabaseTable_columnsConnection_nodes;
export type GridRowData = TableColumnsGridRowData;

export type TableColumnsQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<ColumnsValidSortFields> & {
    readonly tableId: string;
    readonly rowCount: number | null;
    readonly hackyUpdateNumber: number;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tablesConnection &&
    resultData.tablesConnection.nodes[0] &&
    resultData.tablesConnection.nodes[0].columnsConnection;
}

export function mapResultNode(node: QueryResultListNode, resultData: QueryResults): GridRowData {
  return {
    ...node,
    tags: filterOutNullAndUndefined(node.tags.map(t => t.name)),
    datasourceCount: node.downstreamDatasourcesConnection ? node.downstreamDatasourcesConnection.totalCount : null,
    sheetCount: node.downstreamSheetsConnection ? node.downstreamSheetsConnection.totalCount : null,
    tableId: resultData && resultData.tablesConnection && resultData.tablesConnection.nodes
      && resultData.tablesConnection.nodes[0] ? resultData.tablesConnection.nodes[0].id : '',
  };
}

export function TableColumnsQueryGrid(props: TableColumnsQueryGridProps): JSX.Element {
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={TableColumnsByIdQueryGql}
      partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as ColumnSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
      hackyUpdateNumber={props.hackyUpdateNumber}
    >
      {({ rowStore }) => (
        <TableColumnsDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          orderBy={props.orderBy}
          updateSelectionForKey={props.updateSelectionForKey}
          updateSortOrder={props.updateSortOrder}
          rowCount={props.rowCount}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
